import React, { useState } from 'react';
import 'fontsource-roboto';
import { Formik, Form } from 'formik';
import { Paper, Typography, Grid, CssBaseline, LinearProgress } from '@material-ui/core';
import useStyles from './Support-form.style';

function SupportForm({ initialValues, service, langConf, FormComponent }) {

    const classes = useStyles();
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    const [isDone, setIsDone] = useState(false);

    const formTitle = () => {
        if (isDone) {
            return isError ? langConf.errors.view.title : langConf.success.view.title;
        }
        return langConf.title;
    }

    const submit = (formData) => {
        setLoading(true);
        service.submitFormData(formData)
            .then(res => {
                setLoading(false);
                setIsDone(true)
            })
            .catch(error => {
                setLoading(false);
                setError(true);
                setIsDone(true)
            })
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <main className={`${classes.layout} ${isDone ? 'done' : ''}`}>
                <Paper className={`${classes.paper} paper-form`}>
                    <h1 align="center">{formTitle()}</h1>
                    <React.Fragment>
                        {isDone ? (
                            <React.Fragment>
                                <Typography variant="h5" gutterBottom align="center">
                                    {isError ? langConf.errors.view.message : langConf.success.view.message}
                                </Typography>
                            </React.Fragment>
                        ) : (
                            <Formik initialValues={initialValues}
                                validate={service.formValidation}
                                onSubmit={submit}>
                                {({ submitForm, ...props }) => (
                                    <Form>
                                        {isLoading ? <LinearProgress /> : null}
                                        <Grid container spacing={3} className="main-form-wrapper">
                                            <FormComponent config={langConf} initialValues={initialValues} {...props} />
                                            {Boolean(langConf.formBottomText)
                                                ?
                                                <Grid item xs={12} align="center">
                                                    <p>{langConf.formBottomText}</p>
                                                </Grid>
                                                : null}
                                            <Grid item xs={12}>
                                                <div className={`container-contact100-form-btn ${isLoading ? 'disabled-container' : ''}`}>
                                                    <div className="wrap-contact100-form-btn">
                                                        <div className="contact100-form-bgbtn"></div>
                                                        <div id="submit-button" className="contact100-form-btn" onClick={submitForm}>
                                                            <span>
                                                                {langConf.submitButton}
                                                                <svg className="submit-arrow" viewBox="0 0 24 24">
                                                                    <path fill="currentColor" d="M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        )}
                    </React.Fragment>
                </Paper>
            </main>
        </React.Fragment>
    )

}

export default SupportForm;